import { type ColumnDef, isColGroup } from "./isColGroup"

export function getColumnNames(
  colDefs: Array<ColumnDef>,
  result: Array<string> = []
): Array<string> {
  colDefs.forEach((col) => {
    if (isColGroup(col)) {
      result = getColumnNames(col.children, result)
    } else {
      if (col.hide !== true && typeof col.colId !== "undefined") {
        result.push(col.colId!)
      }
    }
  })

  return result
}
